var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterFooter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Twitter social icons - circle - blue",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\u6955\\u5186\\u5F62 457",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 4170",
    d: "M16.34 30.55a13.628 13.628 0 0013.72-13.72c0-.21 0-.42-.01-.62a9.879 9.879 0 002.41-2.5 9.787 9.787 0 01-2.77.76 4.819 4.819 0 002.12-2.67 9.765 9.765 0 01-3.06 1.17 4.825 4.825 0 00-8.34 3.3 4.419 4.419 0 00.13 1.1 13.679 13.679 0 01-9.94-5.04 4.82 4.82 0 001.5 6.43 4.737 4.737 0 01-2.18-.6v.06a4.827 4.827 0 003.87 4.73 4.807 4.807 0 01-1.27.17 4.6 4.6 0 01-.91-.09 4.815 4.815 0 004.5 3.35 9.693 9.693 0 01-5.99 2.06 8.768 8.768 0 01-1.15-.07 13.435 13.435 0 007.37 2.18"
  })));
}
export default SvgTwitterFooter;